<template>
  <section class="services-section">
    <div class="section-container">
      <div class="section-header">
        <span class="section-label">Nos Solutions</span>
        <h2 class="section-title">Nos services financiers adaptés à vos besoins</h2>
        <p class="section-subtitle">
          Découvrez notre gamme complète de produits conçus pour répondre 
          aux besoins des particuliers et des professionnels.
        </p>
      </div>

      <div class="services-grid">
        <div 
          class="service-card" 
          v-for="(service, index) in services" 
          :key="index"
        >
          <div class="service-icon" v-html="service.icon"></div>
          <h3>{{ service.title }}</h3>
          <p>{{ service.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesSection',
  data() {
    return {
      services: [
        {
          title: 'Prêts Personnels',
          description: "Jusqu'à 5 millions FCFA avec des conditions flexibles",
          icon: '<svg viewBox="0 0 24 24"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>'
        },
        {
          title: 'Microcrédit Pro',
          description: 'Développez votre activité avec notre soutien',
          icon: '<svg viewBox="0 0 24 24"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"/></svg>'
        },
        {
          title: 'Épargne Sécurisée',
          description: 'Faites fructifier votre capital en toute sécurité',
          icon: '<svg viewBox="0 0 24 24"><path d="M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16"/><path d="M3 21h18"/><path d="M9 7h6"/><path d="M9 11h6"/><path d="M9 15h6"/></svg>'
        },
        {
          title: 'Crédit Immobilier',
          description: 'Accédez à la propriété avec des taux avantageux',
          icon: '<svg viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M9 22V12h6v10"/></svg>'
        },
        {
          title: 'Assurance Crédit',
          description: 'Protégez-vous contre les aléas de la vie',
          icon: '<svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>'
        },
        {
          title: 'Comptes Pro',
          description: 'Solutions bancaires pour votre entreprise',
          icon: '<svg viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>'
        },
        {
          title: 'Finance Agricole',
          description: 'Crédits adaptés aux cycles agricoles',
          icon: '<svg viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>'
        },
        {
          title: 'Transferts',
          description: "Envoyez et recevez de l'argent facilement",
          icon: '<svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>'
        }
      ]
    }
  }
}
</script>

<style scoped>
.services-section {
  padding: 6rem 2rem;
  background: linear-gradient(180deg, var(--off-white) 0%, var(--white) 100%);
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  max-width: 700px;
  margin: 0 auto 4rem;
}

.section-label {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: rgba(37, 99, 235, 0.1);
  color: var(--accent-blue);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  border-radius: 50px;
  margin-bottom: 1rem;
}

.section-title {
  font-family: var(--font-display);
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: var(--gray-900);
  line-height: 1.2;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: var(--gray-600);
  line-height: 1.7;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}

.service-card {
  position: relative;
  padding: 2rem;
  background: var(--white);
  border-radius: 20px;
  border: 1px solid var(--gray-100);
  text-align: center;
  transition: var(--transition-base);
  cursor: pointer;
  overflow: hidden;
}

.service-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  background: linear-gradient(135deg, var(--primary-blue), var(--accent-blue));
  transition: var(--transition-slow);
  z-index: 0;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: var(--shadow-2xl);
  border-color: transparent;
}

.service-card:hover::after {
  height: 100%;
}

.service-card:hover .service-icon,
.service-card:hover h3,
.service-card:hover p {
  color: var(--white);
  position: relative;
  z-index: 1;
}

.service-card:hover .service-icon :deep(svg) {
  stroke: var(--white);
}

.service-card:hover .service-icon {
  background: rgba(255, 255, 255, 0.2);
}

.service-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(37, 99, 235, 0.1);
  border-radius: 16px;
  transition: var(--transition-base);
}

.service-icon :deep(svg) {
  width: 28px;
  height: 28px;
  stroke: var(--accent-blue);
  stroke-width: 1.5;
  fill: none;
  transition: var(--transition-base);
}

.service-card h3 {
  font-family: var(--font-display);
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: 0.5rem;
  transition: var(--transition-base);
}

.service-card p {
  font-size: 0.85rem;
  color: var(--gray-600);
  line-height: 1.6;
  transition: var(--transition-base);
}

@media (max-width: 1200px) {
  .services-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1024px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .services-section {
    padding: 4rem 1.5rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }
}
</style>
